<script lang="ts">
  import { Container } from '@shared/ui/container';
  import Contacts from './contacts.svelte';
  import Socials from './socials.svelte';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';
  import { page } from '$app/stores';
  import { LogoDO } from '@shared/lib/lotties';
  import { InstitutionsSubscribeForm } from '@features/institutions-subscribe';

  const fullLogoIconUID = Symbol();
  const fullLogoTextUID = Symbol();

  $: image = $page.data.configurations.logo;
  $: name = $page.data.configurations.name;
</script>

<footer class="bg-alt-dark text-default-50">
  <Container containerClass="py-6 md:py-8 lg:py-12">
    <DirectusImage
      imageData="{image}"
      alt="{image.title}"
      imgClasses="w-auto h-[28px] max-w-[210px] object-contain invert mb-12 lg:mb-15"
      attributes="{{
        draggable: false,
      }}"
      pictureSizes="{{ default: '200px' }}"
      presetKeys="{Preset.Thumbnail}"
      loading="lazy"
    />

    <div class="mb-15 uw:gap-12 flex flex-col gap-8 md:grid md:grid-cols-2 xl:grid-cols-12 xl:gap-10">
      <div class="uw:col-end-3 xl:col-start-1 xl:col-end-4">
        <Contacts />
      </div>

      <div class="md:cols-start-2 uw:col-start-3 uw:col-end-6 md:flex md:justify-end xl:col-start-5 xl:col-end-8">
        <Socials />
      </div>

      <div class="xl:col-span-4 xl:col-start-9 xl:col-end-13">
        <p class="mb-4 text-xl">
          Stay up to date with the latest updates and news with <span class="break-words">{name}</span>
        </p>

        <InstitutionsSubscribeForm />
      </div>
    </div>

    <div class="flex items-center gap-3">
      <p class="text-base">© Powered by</p>

      <a href="https://digitaloriginal.app" target="_blank">
        <LogoDO width="{94}" iconUID="{fullLogoIconUID}" textUID="{fullLogoTextUID}" />
      </a>
    </div>
  </Container>
</footer>
